module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.enrollments || _vm.orphaned.length) ? _c('div', {
    staticClass: "metrics-container"
  }, [_vm._l((_vm.enrollments), function(enrollment) {
    return _c('div', {
      key: enrollment.id
    }, [_c('h4', [_vm._v("Marks for " + _vm._s(_vm.getProgramName(enrollment.programId)) + " " + _vm._s(_vm._f("intakeDate")(enrollment.intake)))]), _vm._v(" "), _vm._l((enrollment.marks), function(metric) {
      return (metric.term.type !== 'mentorship') ? _c('div', {
        staticClass: "term-metrics"
      }, [_c('div', {
        staticClass: "term-header",
        on: {
          "click": function($event) {
            _vm.toggleTerm(metric.term.id)
          }
        }
      }, [(_vm.selectedTerms.includes(metric.term.id)) ? _c('i', {
        staticClass: "fa fa-caret-down"
      }) : _c('i', {
        staticClass: "fa fa-caret-right"
      }), _vm._v("\n                    " + _vm._s(metric.term.name) + "\n                    "), (new Date(metric.term.endDate) < new Date()) ? _c('span', {
        staticClass: "total-mark"
      }, [_vm._v("\n                        " + _vm._s(metric.totalMark) + "%  " + _vm._s(_vm.letterGrade(metric.totalMark)) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.selectedTerms.includes(metric.term.id)),
          expression: "selectedTerms.includes(metric.term.id)"
        }],
        staticClass: "metrics"
      }, [_c('div', [(_vm.usesNewMarkingSystem(metric)) ? _c('span', {
        staticClass: "bold"
      }, [_vm._v("10% Live Session Attendance")]) : _c('span', {
        staticClass: "bold"
      }, [_vm._v("25% Metrics")]), _vm._v(" "), (!_vm.usesNewMarkingSystem(metric)) ? _c('div', {
        staticClass: "indent clearfix"
      }, [_vm._v("10% Video Progress: "), _c('span', {
        staticClass: "mark"
      }, [_vm._v(_vm._s(metric.video.mark) + "% " + _vm._s(metric.video.progress) + " / " + _vm._s(metric.video.totalDuration))])]) : _vm._e(), _vm._v(" "), (!_vm.usesNewMarkingSystem(metric)) ? _c('div', {
        staticClass: "indent clearfix"
      }, [_vm._v("5% Forum / Chat: "), _c('span', {
        staticClass: "mark"
      }, [_vm._v(_vm._s(metric.interactions.mark) + "%")])]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "indent clearfix"
      }, [_vm._v("Attendance: "), _c('span', {
        staticClass: "mark"
      }, [_vm._v(_vm._s(metric.meetings.attended) + " / " + _vm._s(metric.meetings.total))])])]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      }, [_c('span', {
        on: {
          "click": function($event) {
            _vm.toggleAssignments(metric.term.id)
          }
        }
      }, [(_vm.usesNewMarkingSystem(metric)) ? _c('span', {
        staticClass: "bold"
      }, [_vm._v("40% Assignments:")]) : _c('span', {
        staticClass: "bold"
      }, [_vm._v("25% Assignments:")]), _vm._v(" "), (_vm.selectedAssignments.includes(metric.term.id)) ? _c('i', {
        staticClass: "fa fa-caret-down"
      }) : _c('i', {
        staticClass: "fa fa-caret-right"
      })]), _vm._v(" "), _c('span', {
        staticClass: "mark"
      }, [_vm._v(_vm._s(metric.assignments.mark) + "%")]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.selectedAssignments.includes(metric.term.id)),
          expression: "selectedAssignments.includes(metric.term.id)"
        }],
        staticClass: "submissions"
      }, _vm._l((metric.assignments.assignments), function(assignment) {
        return _c('div', [_vm._v("                                                \n                                Week " + _vm._s(assignment.week) + ":\n                                "), (assignment.instance['associated.name']) ? _c('span', [_vm._v(_vm._s(assignment.instance['associated.name']))]) : _vm._e(), _vm._v("\n                                – " + _vm._s(assignment.name) + "\n                                "), (assignment.submission) ? _c('span', {
          staticClass: "mark"
        }, [(assignment.submission.grade == null) ? _c('span', [_vm._v("Ungraded")]) : _c('span', [_vm._v(_vm._s(assignment.submission.grade))]), _vm._v(" "), (assignment.submission.grade != null) ? _c('span', [_vm._v("%")]) : _vm._e()]) : _c('span', {
          staticClass: "mark"
        }, [_vm._v("Incomplete")])])
      }))]), _vm._v(" "), _c('div', {
        staticClass: "clearfix"
      }, [_c('span', {
        staticClass: "bold"
      }, [_vm._v("50% Final Project:")]), _vm._v(" "), (metric.finalProject && new Date(metric.term.endDate) < new Date()) ? _c('span', {
        staticClass: "mark"
      }, [(metric.finalProject.submission && isNaN(metric.finalProject.mark)) ? _c('span', [_vm._v("Ungraded")]) : _vm._e(), _vm._v(" "), (!metric.finalProject.submission) ? _c('span', [_vm._v("Incomplete")]) : _vm._e(), _vm._v(" "), (metric.finalProject.submission && metric.finalProject.mark) ? _c('span', [_vm._v("\n                                " + _vm._s(metric.finalProject.mark) + "%\n                            ")]) : _vm._e()]) : _vm._e()])])]) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('h4', [_vm._v("Marks for Un-Enrolled Terms")]), _vm._v(" "), _vm._l((_vm.orphaned), function(metric) {
    return (metric.term.type !== 'mentorship') ? _c('div', {
      staticClass: "term-metrics"
    }, [_c('div', {
      staticClass: "term-header",
      on: {
        "click": function($event) {
          _vm.toggleTerm(metric.term.id)
        }
      }
    }, [(_vm.selectedTerms.includes(metric.term.id)) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    }), _vm._v("\n                    " + _vm._s(metric.term.name) + "\n                    "), (new Date(metric.term.endDate) < new Date()) ? _c('span', {
      staticClass: "total-mark"
    }, [_vm._v("\n                        " + _vm._s(metric.totalMark) + "%  " + _vm._s(_vm.letterGrade(metric.totalMark)) + "\n                    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedTerms.includes(metric.term.id)),
        expression: "selectedTerms.includes(metric.term.id)"
      }],
      staticClass: "metrics"
    }, [_c('div', [(_vm.usesNewMarkingSystem(metric)) ? _c('span', {
      staticClass: "bold"
    }, [_vm._v("10% Live Session Attendance")]) : _c('span', {
      staticClass: "bold"
    }, [_vm._v("25% Metrics")]), _vm._v(" "), (!_vm.usesNewMarkingSystem(metric)) ? _c('div', {
      staticClass: "indent clearfix"
    }, [_vm._v("10% Video Progress: "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.video.mark) + "% " + _vm._s(metric.video.progress) + " / " + _vm._s(metric.video.totalDuration))])]) : _vm._e(), _vm._v(" "), (!_vm.usesNewMarkingSystem(metric)) ? _c('div', {
      staticClass: "indent clearfix"
    }, [_vm._v("5% Forum / Chat: "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.interactions.mark) + "%")])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "indent clearfix"
    }, [_vm._v("Attendance: "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.meetings.attended) + " / " + _vm._s(metric.meetings.total))])])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      on: {
        "click": function($event) {
          _vm.toggleAssignments(metric.term.id)
        }
      }
    }, [(_vm.usesNewMarkingSystem(metric)) ? _c('span', {
      staticClass: "bold"
    }, [_vm._v("40% Assignments:")]) : _c('span', {
      staticClass: "bold"
    }, [_vm._v("25% Assignments:")]), _vm._v(" "), (_vm.selectedAssignments.includes(metric.term.id)) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    })]), _vm._v(" "), _c('span', {
      staticClass: "mark"
    }, [_vm._v(_vm._s(metric.assignments.mark) + "%")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.selectedAssignments.includes(metric.term.id)),
        expression: "selectedAssignments.includes(metric.term.id)"
      }],
      staticClass: "submissions"
    }, _vm._l((metric.assignments.assignments), function(assignment) {
      return _c('div', [_vm._v("                                                \n                                Week " + _vm._s(assignment.week) + ":\n                                "), (assignment.instance['associated.name']) ? _c('span', [_vm._v(_vm._s(assignment.instance['associated.name']))]) : _vm._e(), _vm._v("\n                                – " + _vm._s(assignment.name) + "\n                                "), (assignment.submission) ? _c('span', {
        staticClass: "mark"
      }, [(assignment.submission.grade == null) ? _c('span', [_vm._v("Ungraded")]) : _c('span', [_vm._v(_vm._s(assignment.submission.grade))]), _vm._v(" "), (assignment.submission.grade != null) ? _c('span', [_vm._v("%")]) : _vm._e()]) : _c('span', {
        staticClass: "mark"
      }, [_vm._v("Incomplete")])])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    }, [_c('span', {
      staticClass: "bold"
    }, [_vm._v("50% Final Project:")]), _vm._v(" "), (metric.finalProject && new Date(metric.term.endDate) < new Date()) ? _c('span', {
      staticClass: "mark"
    }, [(metric.finalProject.submission && isNaN(metric.finalProject.mark)) ? _c('span', [_vm._v("Ungraded")]) : _vm._e(), _vm._v(" "), (!metric.finalProject.submission) ? _c('span', [_vm._v("Incomplete")]) : _vm._e(), _vm._v(" "), (metric.finalProject.submission && metric.finalProject.mark) ? _c('span', [_vm._v("\n                                " + _vm._s(metric.finalProject.mark) + "%\n                            ")]) : _vm._e()]) : _vm._e()])])]) : _vm._e()
  })], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53e9e020!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/StudentAdminStatus.vue
// module id = 2047
// module chunks = 2